<div class="pmd-sidebar-scrollbar sidebar_submenu">
	<p class="p-3 mb-0 text-dark fw-semibold">{{menu?.name}}</p>
	<app-sub-menu-options *ngIf="menu.subMenus?.length"
		[options]="menu?.subMenus"></app-sub-menu-options>
</div>